<template>
  <div>
    <TitlePage :title="$t('profile')"></TitlePage>

    <v-layout wrap>

      <v-container fluid>
        <v-row>
          <v-col cols="12" md="4" class="text-center">
            <v-card class="pt-5 pb-5">
              <v-avatar color="primary" size="67" dark>
                <span class="white--text text-h5">{{getAvatarShort(getUser.full_name)}}</span>
              </v-avatar>

              <v-card-text>
                <h4>{{getUser.full_name}}</h4>
                <p>{{getUser.email}}</p>

                <div class="mt-0">
                  <span v-if="getUser.super_admin" style="font-size: 10px">
                    <v-chip color="error" label x-small text-color="white">{{ $t('superAdmin') }}</v-chip>
                  </span>
                  <span v-if="!getUser.super_admin && getUser.center_id" style="font-size: 10px">
                    <v-chip color="green" label x-small text-color="white">{{ $t('adminCenter') }}</v-chip>
                  </span>
                </div>

              </v-card-text>


            </v-card>

          </v-col>
          <v-col cols="12" md="8">
            <v-card class="pt-5 pb-5">
              <v-layout wrap>
                <v-flex md6 class="pl-4 pr-4">
                  <v-text-field :label="$t('name')" v-model="form.full_name" :rules="validation.textRules" :error-messages="errors.full_name"></v-text-field>
                </v-flex>
                <v-flex md6 class="pl-4 pr-4">
                  <v-text-field :label="$t('email')" v-model="form.email" disabled readonly></v-text-field>
                </v-flex>
                <v-flex md4 class="pl-4 pr-4">
                  <v-text-field :label="$t('password_actual')" v-model="form.password"
                                :append-icon="showPassword1 ? 'mdi-eye' : 'mdi-eye-off'" :type="showPassword1 ? 'text' : 'password'"
                                @click:append="showPassword1 = !showPassword1" :error-messages="errors.password"
                  ></v-text-field>
                </v-flex>
                <v-flex md4 class="pl-4 pr-4">
                  <v-text-field :label="$t('password_new')" v-model="form.password_new"
                                :append-icon="showPassword2 ? 'mdi-eye' : 'mdi-eye-off'" :type="showPassword2 ? 'text' : 'password'"
                                @click:append="showPassword2 = !showPassword2" :error-messages="errors.password_new"
                  ></v-text-field>
                </v-flex>
                <v-flex md4 class="pl-4 pr-4">
                  <v-text-field :label="$t('password_new_confirm')" v-model="form.password_new_confirm"
                                :append-icon="showPassword3 ? 'mdi-eye' : 'mdi-eye-off'" :type="showPassword3 ? 'text' : 'password'"
                                @click:append="showPassword3 = !showPassword3" :rules="validation.passwordMatch" :error-messages="errors.password_new_confirm"
                  ></v-text-field>
                </v-flex>

                <v-flex md12 class="pl-4 pr-4 pt-5 d-flex">
                  <v-btn elevation="2" color="" class="mr-auto" @click="$router.go(-1)">
                    <v-icon left>mdi-keyboard-backspace</v-icon>
                    {{ $t('back') }}
                  </v-btn>
                  <v-btn elevation="2" color="primary" class="ml-auto" @click="save" type="submit">
                    {{ $t('save') }}
                    <v-icon right>mdi-content-save</v-icon>
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-card>
          </v-col>

        </v-row>
      </v-container>
    </v-layout>
  </div>
</template>

<script>

import TitlePage from "../components/utils/TitlePage";
import {mapActions, mapGetters, mapMutations} from "vuex";
export default {
  name: 'Profile',
  components: {TitlePage},
  data() {
    return {
      check: true,
      showPassword1:false,
      showPassword2:false,
      showPassword3:false,
      form:{
        full_name: '',
        email: '',
        password: '',
        password_new: '',
        password_new_confirm: ''
      },
      errors:{
        full_name: '',
        password: '',
        password_new: '',
        password_new_confirm: '',
      },
      validation: {
        textRules: [
          v => !!v || this.$t('fillMandatory'),
        ],
        passwordMatch:[
            v => v == this.form.password_new || this.$t('password_not_match')
        ]
      }
    };
  },
  created() {
    this.form.full_name = this.getUser.full_name
    this.form.email = this.getUser.email
  },
  methods: {
    ...mapMutations({
      'setLoading': 'settings/setLoading',
      'setNotification': 'settings/setNotification',
      'setUser': 'user/setUser',
    }),
    ...mapActions({
      'updateProfile': 'user/updateProfile',
      'logout': 'user/logout',
    }),
    getAvatarShort(name){
      var split = name.split(' ')
      if(split.length > 1){
        return split[0].charAt(0)+split[1].charAt(0)
      }else {
        return name.charAt(0).toUpperCase()+name.charAt(1).toUpperCase()
      }
    },

    async save(){

      await this.checkItem()
      if(!this.check){
        return
      }else {
        await this.resetError()
      }

      await this.setLoading(true);
      var result = await this.updateProfile(this.form)
      await this.setLoading(false);

      if(result.success){

        if(this.form.password_new != ''){

          this.setNotification({
            active: true,
            color: 'success',
            mode: 'multi-line',
            text: this.$t('makeLoginAgain')
          })

          await this.logout()
          this.$router.push('/login');

        }else {

          this.setNotification({
            active: true,
            color: 'success',
            mode: 'multi-line',
            text: this.$t('updateSuccess')
          })

          var user = await this.getUser
          user.full_name = this.form.full_name

          await this.setUser(user)
          localStorage.setItem('user', JSON.stringify(user))

        }


      }else {

        var text = result;

        switch (result.message) {
          case "credentials_not_valid":{
            text = this.$t('password_actual_not_correct')
          }
        }

        this.setNotification({
          active: true,
          color: 'error',
          mode: 'multi-line',
          text: text
        })

      }

    },
    async checkItem(){

      this.check = true

      if(!this.form.full_name){
        this.check = false
        this.errors.full_name = this.$t('fillMandatory');
      }

      if(!this.form.password){
        this.check = false
        this.errors.password = this.$t('fillMandatory');
      }

      if(this.form.password_new != '' || this.form.password_new_confirm != ''){

        if(!this.form.password_new){
          this.check = false
          this.errors.password_new = this.$t('fillMandatory');
        }

        if(!this.form.password_new_confirm){
          this.check = false
          this.errors.password_new_confirm = this.$t('fillMandatory');
        }

        if(this.form.password_new != this.form.password_new_confirm){
          this.check = false
          this.errors.password_new_confirm = this.$t('password_not_match');
        }

      }

    },
    async resetError(){
      this.errors = {
        full_name: '',
        password: '',
        password_new: '',
        password_new_confirm: '',
      }
    }

  },
  computed: {
    ...mapGetters({
      'getUser': 'user/getUser',
    }),
  },
}
</script>
